// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".xgplayer-skin-skinName .xgplayer-placeholder {\n  flex: 1;\n  order: 3;\n  display: block; }\n", ""]);
// Exports
module.exports = exports;
